export default __webpack_public_path__ + "static/media/clinicThumb3.0c0a2149.svg";